import { render } from "./AuthFormConfirmation.vue?vue&type=template&id=4a0654fa"
import script from "./AuthFormConfirmation.vue?vue&type=script&lang=ts"
export * from "./AuthFormConfirmation.vue?vue&type=script&lang=ts"
script.render = render

export default script